/**
 * @class {RoadgamesEvent.InProgress}
 * @extends {RoadgamesEvent.Base}
 * @param {DR.events.struct.Event} event
 * @param {DR.events.struct.Stats} stats
 */
RoadgamesEvent.InProgress = Class(
	{
		/**
		 * @lends {RoadgamesEvent.InProgress#}
		 */
		__NAME: 'RoadgamesEvent.InProgress',

		state: 'in-progress',

		_draw() {
			this._drawWelcome();
			this._drawTopSponsors();
			this._drawInfoBlock();
			this._drawApiGallery();
			this._drawTasksSlider();
			this._drawSteps();
			this._drawPrizeSponsors();
			this._drawInstagramFeed();
			this._drawTestimonials();
			this._drawExperience();
			this._drawGiftCards();
			this._drawCta();
		},

		_drawWelcomeBottom() {
			if( this.event.hasTeam ) {
				return mkE({
					tag: 'div',
					className: 'single-event-welcome-purchase',
					els: [
						{
							tag: 'a',
							href: D.url('/profile/event/' + this.event.seoTitle),
							className: 'button button-turquoise',
							text: D.Lang.get('event.myTeam')
						}
					]
				});
			}
			if (this.isRace) {
				return;
			}
			if( this.event.settings.isFreeGame ) {
				return mkE({
					tag: 'div',
					className: 'single-event-welcome-purchase',
					els: [
						{
							tag: 'div',
							className: 'button-container',
							els: [
								this._buyBtn = mkE({
									tag: 'a',
									href: D.url(D.Lang.get('home.welcome.button.link')),
									className: 'button button-pink',
									text: D.Lang.get('home.welcome.button')
								})
							]
						},
						{
							tag: 'div',
							className: 'price-container',
							els: [
								{
									tag: 'div',
									className: 'price',
									text: D.Lang.get('event.freeGame')
								}
							]
						}
					]
				});
			}
			let activePriceIndex = this.event.ticket.prices.findIndex(price => price.isActive);
			if( activePriceIndex === -1 ) {
				return mkE({
					tag: 'div',
					className: 'single-event-welcome-purchase single-event-welcome-download',
					els: [
						{
							tag: 'div',
							className: 'button-container',
							els: [
								this._buyBtn = mkE({
									tag: 'a',
									href: D.url(D.Lang.get('home.welcome.button.link')),
									className: 'button button-pink',
									text: D.Lang.get('home.welcome.button')
								})
							]
						},
						new T.Download('', 'default')
					]
				});
			}
			return '';
		},

		_drawCta: function () {
			if( this.event.hasTeam ) {
				return;
			}
			let els;
			if( this.event.settings.isFreeGame ) {
				els = [
					{
						tag: 'div',
						className: 'button-container',
						els: [
							{
								tag: 'a',
								href: D.url(D.Lang.get('home.welcome.button.link')),
								className: 'button button-pink',
								text: D.Lang.get('home.welcome.button')
							}
						]
					},
					{
						tag: 'div',
						className: 'price-container',
						els: [
							{
								tag: 'div',
								className: 'price price-free',
								text: D.Lang.get('event.freeGame')
							}
						]
					}
				];
			} else {
				let activePriceIndex = this.event.ticket.prices.findIndex(price => price.isActive);
				if( activePriceIndex === -1 ) {
					els = [
						{
							tag: 'div',
							className: 'button-container',
							els: [
								{
									tag: 'a',
									href: D.url(D.Lang.get('home.welcome.button.link')),
									className: 'button button-pink',
									text: D.Lang.get('home.welcome.button')
								}
							]
						},
						new T.Download('', 'default')
					];
				}
			}
			this._cta = new T.CallToAction({
				els: els
			}).append(document.body);
		},

		onScroll: function () {
			if( this._cta && this._buyBtn ) {
				if( this._buyBtn.offsetTop + 200 < window.scrollY ) {
					if( !this._cta.active ) {
						this._cta.show();
					}
				} else if( this._cta.active ) {
					this._cta.hide();
				}
			}
		},

		onShow() {
			PARENT.onShow();
			this.onScroll();
		},

		onLeave: function () {
			PARENT.onLeave();
			if( this._cta ) {
				this._cta.remove();
				this._cta = null;
			}
		}
	},
	RoadgamesEvent.Base
);


/**
 * @class {RoadgamesEvent.InProgress.Race}
 * @extends {RoadgamesEvent.InProgress}
 * @param {DR.events.struct.Event} event
 * @param {DR.events.struct.Stats} stats
 * @param {DR.top.GetTop} top
 */
RoadgamesEvent.InProgress.Race = Class(
	{
		/**
		 * @lends {RoadgamesEvent.InProgress.Race#}
		 */
		__NAME: 'RoadgamesEvent.Registration.Race',

		state: 'in-progress',

		/** @type {DR.events.struct.Event} */
		event: null,

		_draw() {
			this._drawWelcome();
			this._drawTopSponsors();
			this._drawInfoBlock();
			this._drawTasksSlider();
			this._drawSteps();
			this._drawPrizeSponsors();
			this._drawLiveAwards();
			this._drawApiGallery();
			this._drawExperience();
			this._drawTestimonials();
			this._drawInstagramFeed();
			this._drawGiftCards();
		},

		onShow() {
			PARENT.onShow();
			if( this._prizeSpoonsorsSlider ) {
				this._prizeSpoonsorsSlider.onShow();
			}
		}
	},
	RoadgamesEvent.InProgress
);